import React, { useEffect, useState } from "react";
import { MAINTENANCE_CATEGORIES } from "../../constants/maintenanceCategories";
import "./ResidentMaintenance.css";

export default function ResidentMaintenance() {
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [issues, setIssues] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const API = process.env.REACT_APP_API_URL;
  const authHeader = { Authorization: `Bearer ${localStorage.getItem("residentToken")}` };

  const loadIssues = async () => {
    try {
      const res = await fetch(`${API}/api/maintenance/mine`, { headers: authHeader });
      if (!res.ok) {
        setError("Failed to load your issues");
        return;
      }
      setIssues(await res.json());
    } catch (err) {
      setError("Server error while loading issues");
    }
  };

  useEffect(() => {
    loadIssues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!category || !description) {
      setError("Please select a category and describe the issue");
      return;
    }

    try {
      const res = await fetch(`${API}/api/maintenance`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeader },
        body: JSON.stringify({ category, description }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || "Failed to report issue");
      }

      setCategory("");
      setDescription("");
      setSuccess("Issue reported");
      loadIssues();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="resident-layout">
      
      <div className="resident-content">
        <h1 className="maintenance-title">Report a Maintenance Issue</h1>

        {error && <p className="maintenance-error">{error}</p>}
        {success && <p className="maintenance-success">{success}</p>}

        <form onSubmit={handleSubmit} className="maintenance-form">
          <label className="maintenance-label">
            Issue category
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="maintenance-input">
              <option value="">Select an issue</option>
              {MAINTENANCE_CATEGORIES.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </label>

          <label className="maintenance-label">
            Description
            <textarea
              className="maintenance-textarea"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe the issue in a bit more detail..."
            />
          </label>

          <button type="submit" className="maintenance-submit">Report Issue</button>
        </form>

        <h2 className="maintenance-history-heading">Your Reported Issues</h2>

        <div className="maintenance-list">
          {issues.map((i) => (
            <div className="maintenance-item" key={i.id}>
              <div className="maintenance-item-header">
                <span className="maintenance-item-category">{i.category}</span>
                <span className={`status-badge status-${i.status.replace(/\s/g, "")}`}>{i.status}</span>
              </div>
              <div className="maintenance-item-desc">{i.description}</div>
              {i.acknowledgedBy && (
                <div className="maintenance-item-ack">
                  Acknowledged by {i.acknowledgedBy.name}
                </div>
              )}
              {i.updatedBy && (
                <div className="maintenance-item-ack">
                  Last updated by {i.updatedBy.name} — {new Date(i.updatedAt).toLocaleString()}
                </div>
              )}
              <div className="maintenance-item-date">
                Reported {new Date(i.createdAt).toLocaleString()}
              </div>
            </div>
          ))}

          {issues.length === 0 && !error && (
            <p className="maintenance-empty">You haven't reported any issues yet</p>
          )}
        </div>
      </div>
    </div>
  );
}